import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

const ProductMenuBar = ({ menuTab = "product", setMenuTab = () => {} }) => {
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        width: "100%",
        typography: "body1",
        mb: 2,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Tabs
        value={menuTab}
        onChange={(e, newValue) => {
          setMenuTab(newValue);
        }}
        variant="scrollable"
        scrollButtons={false}
        aria-label="scrollable prevent tabs"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#E13B30",
          },
          "& .MuiTab-root.Mui-selected .MuiTypography-root": {
            color: "#E13B30",
          },
          "& .MuiTab-root.Mui-selected .MuiBadge-root .MuiBadge-badge": {
            backgroundColor: "#E13B30",
          },
        }}
      >
        <Tab
          key={0}
          sx={{ overflow: "initial" }}
          label={
            <Stack direction="row" alignItems={"center"}>
              <Typography
                sx={{
                  fontSize: "1rem",
                }}
              >
                จัดการสินค้า
              </Typography>
            </Stack>
          }
          value={"product"}
        />

        <Tab
          key={1}
          sx={{ overflow: "initial" }}
          label={
            <Stack direction="row" alignItems={"center"}>
              <Typography
                sx={{
                  fontSize: "1rem",
                }}
              >
                จัดการสต็อก
              </Typography>
            </Stack>
          }
          value={"stock"}
        />
      </Tabs>
    </Box>
  );
};

export default ProductMenuBar;
